import React, { useState } from "react";
import { Handshake } from "lucide-react"; // ✅ real handshake icon

export default function Logo({ align = 'center', className = '' }) {
  const [hovered, setHovered] = useState(false);

  const alignmentClass = align === 'left' ? 'items-start text-left' : 'items-center text-center';

  return (
    <div
      className={`relative flex flex-col cursor-pointer select-none ${alignmentClass} ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Handshake Icon */}
      <Handshake
        className={`w-10 h-10 transition-all duration-700 ${
          hovered
            ? "text-cyan-500 scale-110 rotate-0"
            : "text-blue-800 scale-100 -rotate-3"
        }`}
      />

      {/* Brand Name */}
      <h1
        className={`mt-2 font-extrabold text-2xl tracking-widest transition-all duration-700 ${
          hovered
            ? "text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500"
            : "text-blue-800"
        }`}
        style={{ fontFamily: "Poppins, sans-serif" }}
      >
        E2E
      </h1>

      {/* Tagline */}
      <span
        className={`text-[10px] font-medium transition-all duration-700 ${
          hovered ? "text-gray-300 tracking-wide" : "text-gray-500"
        }`}
      >
        JOB POSTING & RECRUITMENTS
      </span>
    </div>
  );
}
